import type { FC, PropsWithChildren } from 'react';

import type translationKey from '@/lib/i18n/TranslationKey.ts';
import useTitle from '@/lib/useTitle.ts';

type NoLayoutProps = {
  title: translationKey;
};
const NoLayout: FC<PropsWithChildren<NoLayoutProps>> = ({ title, children }) => {
  useTitle(title);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default NoLayout;
